import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ConcreteHierarchyItemInterface} from "../../classes/concreteLayers/ConcreteHierarchyItemInterface";
import {Item} from "../../models/Item";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {slideAnimation} from "../../animations/showHideAnimation";
import {animate, animation, style, transition, trigger} from "@angular/animations";
import {KeyListenersService} from "../../services/keyListenersService/key-listeners.service";
import {DraggableService} from "../../services/draggableService/draggable.service";
import {ItemDomService} from "../../services/itemDOMService/item-dom.service";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {concatMap, filter, flatMap, throttleTime} from "rxjs/operators";
import {asyncScheduler, Subject, timer} from "rxjs";
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';

@Component({
  selector: 'app-placed-item-item',
  templateUrl: './placed-item-item.component.html',
  styleUrls: ['./placed-item-item.component.scss'],
  animations: [trigger('slideAnimation', [
    transition(':enter', animation([
      style({opacity: '0', width: '0'}),
      animate('300ms ease-out',  style({opacity: '1', width: '*'}))
    ])),
    transition(':leave', animation([
      style({opacity: '1', width: '*'}),
      animate('300ms ease-out',  style({opacity: '0', width: '0'}))
    ])),
  ]),]
})
export class PlacedItemItemComponent extends AbstractObserver implements OnInit, AfterViewInit {

  @Input() item: Item;
  public isGrayedOut = false;
  public selected = null;
  public isSelectedByMultiSelect = false;
  public isMouseOnElement = false;
  public isViewOnly = isViewMode || isViewModeByShareLink;
  private isAdditionalBlockVisible = false;
  private isCtrlDown = false;
  private leftSidebarScrollbar;
  private dragHandler$ = new Subject<Event>();

  constructor(
      private uiAdapter: UiAdapterService,
      private cd: ChangeDetectorRef,
      private itemDom: ItemDomService,
      private keyListener: KeyListenersService,
      private ds: DraggableService,
      private im: ItemManagerService
  ) {
    super();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    this.leftSidebarScrollbar = Scrollbar.get(document.querySelector('.es-navbar-list-inner-wrapper'));
    this.dragHandler$.pipe(throttleTime(50, asyncScheduler, {trailing: true, leading: true})).subscribe((event:any)=>{
      if (event.clientY < this.leftSidebarScrollbar.bounding.top && this.leftSidebarScrollbar.offset.y > 0){
        return this.leftSidebarScrollbar.scrollTo(this.leftSidebarScrollbar.offset.x, this.leftSidebarScrollbar.offset.y-20, 100);
      }
      if (event.clientY > this.leftSidebarScrollbar.bounding.bottom-30 && this.leftSidebarScrollbar.offset.y < this.leftSidebarScrollbar.limit.y){
        return this.leftSidebarScrollbar.scrollTo(this.leftSidebarScrollbar.offset.x, this.leftSidebarScrollbar.offset.y+20, 100);
      }
    })
  }

  ngOnInit() {
    this.isSelectedByMultiSelect = this.im.selectedItemList.hasOwnProperty(this.item.getId());

    this.subscribeToObservable(this.uiAdapter.selectedItem$,(config: ConcreteHierarchyItemInterface)=>{
      let selectedItem = this.getSelectedItemFromConfig(config);
      if (!(selectedItem instanceof Item)){return}
      this.selected = (selectedItem) ? selectedItem.getCHIId() : null;
      this.cd.detectChanges();
    });

    this.subscribeToObservable(this.im.selectedItemList$, (config)=>{
      this.isSelectedByMultiSelect = config.hasOwnProperty(this.item.getId());
      this.cd.detectChanges();
    });

    this.subscribeToObservable(this.itemDom.isVisible$, ((value)=>{
      this.isAdditionalBlockVisible = value;
      this.cd.detectChanges();
    }));

    this.subscribeToObservable(this.keyListener.currentDown$.pipe(filter(val => (val && val.ctrlKey) || val === null)), (val:KeyboardEvent)=>{
        return this.isCtrlDown = val && val.ctrlKey;
    });

    this.subscribeToObservable(this.item.config.getObjectConfig().subject, ()=>{
      this.cd.detectChanges();
    })
  }

  getSelectedItemFromConfig(config){
    return config;
  }

  dragStart(event){
    if (this.isSelectedByMultiSelect){
      let draggableElmArr = [];
      for (let i in this.im.selectedItemList){
        draggableElmArr.push(this.im.selectedItemList[i]);
      }
      this.ds.draggableElement$ = draggableElmArr;
    }
    else{
      this.ds.draggableElement$ = this.item;
    }
  }

  dragEnd(event) {
    if (this.ds.draggableElementVal) {
      if (this.ds.draggableElementVal && !Array.isArray(this.ds.draggableElementVal) && this.ds.draggableElementVal.getId() == this.item.getId()) {
        this.ds.draggableElement$ = null;
        this.cd.detectChanges();
      }
    }
  }

  dragHandler(event){
    this.dragHandler$.next(event);
  }

  setMouseOnElement(value:boolean){
    this.isMouseOnElement = value;
  }

  isItemElementVisible(){
    if (this.isMouseOnElement){
      return true;
    }
    return this.isAdditionalBlockVisible && this.itemDom.activeItemVal && this.itemDom.activeItemVal.getId() == this.item.getId();
  }

  isVisibleItem(){
    return this.item.getSubjectValue(Item.SUBJECT_LEFT_SIDEBAR_MAIN_VISIBILITY) != false;
  }

  isActive(){
    return (this.selected && this.item.getCHIId() == this.selected) || this.isSelectedByMultiSelect;
  }

  getItemImg(){
    return this.item.config.getObjectConfig().getMapIcon() || this.item.config.getTool().menu_icon || null;
  }

  getItemDetails(){
    if (!this.isCtrlDown) {
      // this.item.onSelect();
      this.uiAdapter.selectedItem$ = this.item;
    }
    if (this.isCtrlDown){
      this.im.toggleSelectedItem(this.item)
    }
    this.cd.detectChanges();
  }

  public centerMapAtObj(item){
    if (!this.isCtrlDown){
      item.centerOnObj();
    }
    this.cd.detectChanges();
  }

}
